import VariableCollapse from "./VariableCollapse";
import { BaseVariableProps } from "../EmailBuilderTypes";
import { Input } from "reactstrap";

const ValueBuilder = ({
  variable,
  setVariables,
  index,
  expandAll,
}: BaseVariableProps) => {
  if (variable.Type !== "Value") return null;

  const Builder = (
    <div className=" px-4 pt-2 pb-4">
      <h4>Value</h4>
      <Input
        bsSize="sm"
        placeholder="Enter variable value"
        value={variable.Value}
        onChange={(e) => handleValueChange(e.target.value)}
      />
    </div>
  );

  return (
    <VariableCollapse
      variable={variable}
      setVariables={setVariables}
      index={index}
      expandAll={expandAll}
    >
      {Builder}
    </VariableCollapse>
  );

  function handleValueChange(newVal: string) {
    setVariables((prev) => {
      return prev.map((variable, i) => {
        if (i !== index) return variable;

        return { ...variable, Value: newVal };
      });
    });
  }
};
export default ValueBuilder;
